// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"369":"ddab2edb","381":"bb705042"}[chunkId] + ".css";
};